import React, { useEffect, useState } from "react";
import axios from "axios";
import BlogsCard from "../BlogsCard";
import "../../styles/Blogs/Blogs.scss";
import "../../styles.css"; // Import the generalized CSS styles

const Blogs = ({ darkTheme }) => {
  const [articles, setArticles] = useState([]);
  const [displayedArticles, setDisplayedArticles] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const text = "BLOGS.";
  const [hoveredIndices, setHoveredIndices] = useState(new Set());

  useEffect(() => {
    fetchArticles(page);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const fetchArticles = async (page) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://dev.to/api/articles?username=aquibpy&page=${page}&per_page=9`
      );
      const newArticles = response.data;

      const filteredNewArticles = newArticles.filter(
        (article) => !articles.find((a) => a.id === article.id)
      );

      if (filteredNewArticles.length === 0) {
        setHasMore(false);
      } else {
        setArticles((prevArticles) => [
          ...prevArticles,
          ...filteredNewArticles,
        ]);
        setDisplayedArticles((prevDisplayed) => [
          ...prevDisplayed,
          ...filteredNewArticles.sort(
            (a, b) => b.public_reactions_count - a.public_reactions_count
          ),
        ]);
      }
    } catch (error) {
      console.error("Error fetching articles:", error);
      setHasMore(false);
    }
    setLoading(false);
  };

  const handleMouseOver = (index) => {
    setHoveredIndices((prev) => new Set(prev.add(index)));
  };

  const handleMouseOut = (index) => {
    // Optional: Remove this function if you want to keep the hover effect persistent
  };

  const handleViewMore = () => {
    if (hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  const articlesToDisplay = displayedArticles.slice(0, 6 + (page - 1));
  const viewMoreButtonVisible =
    hasMore || displayedArticles.length > articlesToDisplay.length;

  return (
    <div className={`blogs ${darkTheme ? "dark" : "light"}`} id="blogs">
      <div className="blogs__container">
        <div className="blogs__header" id="blogs__heading">
          <h1 data-aos="fade-down" className="text-wrapper">
            {text.split("").map((char, index) => (
              <span
                key={index}
                className={hoveredIndices.has(index) ? "gradient-text" : ""}
                onMouseOver={() => handleMouseOver(index)}
                onMouseOut={() => handleMouseOut(index)} // Optional: Remove this if you don't need to reset hover
                style={{ color: darkTheme ? "white" : "black" }}
              >
                {char === " " ? "\u00A0" : char}
              </span>
            ))}
          </h1>
          <p></p>
        </div>
        <div className="blogs__grid">
          <div className="blogs__grid-container">
            {articlesToDisplay.map((article) => (
              <BlogsCard
                key={article.id}
                title={article.title}
                description={article.description}
                url={article.url}
                coverImage={article.cover_image}
                publicReaction={article.public_reactions_count}
                readTime={article.reading_time_minutes}
                darkTheme={darkTheme}
              />
            ))}
            {viewMoreButtonVisible ? (
              <div className="view-more">
                <button
                  onClick={hasMore ? handleViewMore : null}
                  className={`view-more-button ${!hasMore ? "disabled" : ""}`}
                  disabled={loading || !hasMore}
                >
                  {loading
                    ? "Loading..."
                    : hasMore
                    ? "View More"
                    : "No more blogs available."}
                </button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
